/** @jsx jsx */

import { ensureTrailingSlash } from '@zapier/url-utils';
import { Colors, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { useRouter } from 'app/developer-v3/hooks';

import {
  ROUTE_DEPLOY_KEYS,
  ROUTE_EMAIL_SETTINGS,
  ROUTE_PARTNER_SETTINGS,
} from '../constants';
import SidebarLink from './SidebarLink';

const Styles = {
  root: css`
    border-right: 1px solid ${Colors.GrayWarm3};
    display: flex;
    flex-direction: column;
    width: 340px;
  `,
};

function Sidebar() {
  const {
    params: { secret },
    pathname,
  } = useRouter();
  const secretParam = secret ? `/${secret}` : '';

  return (
    <nav css={Styles.root}>
      <header>
        <Text margin="35px 25px 20px 25px" tag="h3" type="Title">
          My partner profile
        </Text>
      </header>
      <section>
        {[ROUTE_PARTNER_SETTINGS, ROUTE_EMAIL_SETTINGS, ROUTE_DEPLOY_KEYS].map(
          navItem => {
            const href = `${navItem.href}${secretParam}`;

            return (
              <SidebarLink
                href={href}
                isActive={
                  ensureTrailingSlash(pathname) === ensureTrailingSlash(href)
                }
                key={navItem.title}
              >
                {navItem.title}
              </SidebarLink>
            );
          }
        )}
      </section>
    </nav>
  );
}

export default Sidebar;
